// extracted by mini-css-extract-plugin
export default {"wrapper":"section-border_wrapper__n4JSX","gapsLine":"section-border_gapsLine__FhhjO"};